export default "/images/storstroems_forsikring.png?761d6e5ae4da0f1e8fe0d59d78170c0d";